import axios from 'axios';
import { loadProgressBar } from 'axios-progress-bar';

import config from './config';
import settings from './settings';
import timeFormat from '@/filters/timeFormat';

const http = axios.create({
  baseURL: `${config.API.sbPlatform[settings.env]}/prematchCompanyAdmin/v1`,
  timeout: 25000,
  params: {},
});

http.interceptors.request.use((options) => {
  /* eslint-disable no-param-reassign */
  options.headers.Authorization = `Bearer ${settings.user.token}`;
  options.headers['SEVEN-LOCALE'] = settings.language;
  options.headers['COMPANY-UUID'] = settings.company.uuid;
  if (settings.user.timezone) options.headers['SEVEN-TIMEZONE'] = settings.user.timezone;
  return options;
}, (err) => {
  console.warn('Request interceptor error: ', err);
  return Promise.reject(err);
});

loadProgressBar({ showSpinner: false }, http);
export default {
  getTranslations(lang) {
    const language = {
      sr_latn: 'sr',
      sr_cyrl: 'sr',
      'sr-latn': 'sr',
      'sr-cyrl': 'sr',
    }[lang.toLowerCase()] || lang;

    return axios.get(`${config.API.tc}/translations/a1da95f58ad6968da18bebbb66a73129/locales/${language}?includeLocaleFallback=true`);
  },
  customSelectionEdit: {
    get(type, params) {
      params.startDate = timeFormat.customSelectionEdit(params.startDate);
      params.endDate = timeFormat.customSelectionEdit(params.endDate);

      return http.get(`/customSelection/${type}`, { params });
    },
    save(data) {
      return http({
        method: 'post',
        url: '/customSelection/multiRequest',
        data: { data: JSON.stringify(data.body) },
      });
    },
    clearAdapterSelection(data) {
      return axios({
        method: 'post',
        url: `${config.API.sbAdapter[settings.env]}/custom-selection/clear-selection/${data.idSelection}`,
        data: {
          companyName: settings.company.name,
        },
      });
    },
    getTournamentBetTemplates(params) {
      return http.get('/customSelectionTournamentsBetTemplates', { params });
    },
  },
};
